import { assoc } from 'ramda';
import { TActions } from '../../types';
import { CHANGE_DICTIONARY_REGIONS, CHANGE_DICTIONARY_COUNTRY_CODES } from './actions';
import { IDictionariesState } from './types';

const initialState: IDictionariesState = {
  countryCodes: [],
  regions: [],
};

export function dictionaries(state: IDictionariesState = initialState, action: TActions) {
  switch (action.type) {
    case CHANGE_DICTIONARY_REGIONS:
      return assoc('regions', action.payload, state);

    case CHANGE_DICTIONARY_COUNTRY_CODES:
      return assoc('countryCodes', action.payload, state);

    default:
      return state;
  }
}
